export default __webpack_public_path__ + "static/media/lineStickr01JP.00927d58.jpg";